import React from "react";
import { ActivityIndicator } from "../loading/ActivityIndicator";

export const DefaultButton = ({ text, loading, onPress, isFlat, left, isDelete }) => {
  return (
    <div className={`defaultButton${isFlat ? ' flat' : ''}${left ? ' left' : ''}${isDelete ? ' delete' : ''}`} onClick={() => onPress ? onPress() : null}>
      {loading ? <ActivityIndicator /> : <span>{text}</span>}
    </div>
  )
}